// Layout dimensions
export const LAYOUT = {
  APP_BAR_HEIGHT: 64,
  DRAWER_WIDTH: 240,
  PADDING: {
    SMALL: 8,  // 1 unit = 8px in Material-UI
    MEDIUM: 16,
    LARGE: 24,
  },
  GAP: {
    SMALL: 8,
    MEDIUM: 16,
    LARGE: 24,
  },
  CONTENT_GAP: {
    APP_BAR: 48, // Gap between AppBar and content
  },
} as const;

// Layout breakpoints (if needed)
export const BREAKPOINTS = {
  MOBILE: 600,
  TABLET: 960,
  DESKTOP: 1280,
} as const;

// Layout z-index values
export const Z_INDEX = {
  DRAWER: 1200,
  APP_BAR: 1100,
  MODAL: 1300,
} as const; 